import React from 'react';

import './index.less';

import IbTypography from '../../common/IbTypography';
import IbIcon from '../../common/IbIcon';
import { AgentMessageModel, ChatMessage } from '../../../../gamma-api';

const MAIN_CLASS_NAME = 'message-attachments';
const ITEM_CLASS_NAME = `${MAIN_CLASS_NAME}__item`;
const ITEM_NAME_CLASS_NAME = `${ITEM_CLASS_NAME}__name`;

export const getAttachments = (chatMessage: ChatMessage): IMessageAttachment[] =>
  (chatMessage.content || [])
    .filter((item) => item.block_type == 'file')
    .map((item) => {
      return { url: item.url ?? '', fileName: item.file_name ?? '', mimeType: item.mime_type ?? '' };
    });

export interface IMessageAttachment {
  url: string;
  fileName: string;
  mimeType: string;
}

export interface IMessageAttachmentsProps {
  message: AgentMessageModel;
}

const MessageAttachments: React.FC<IMessageAttachmentsProps> = ({ message }) => {
  const attachments = getAttachments(message.chat_message);

  if (!attachments.length) {
    return null;
  }

  return (
    <div className={MAIN_CLASS_NAME}>
      {attachments.map((attachment, index) => (
        <a key={index} href={attachment.url} rel="noreferrer" target="_blank">
          <div className={ITEM_CLASS_NAME}>
            <IbIcon iconName="paperclip" size={16} />
            <IbTypography.Paragraph className={ITEM_NAME_CLASS_NAME} type="secondary">
              {attachment.fileName}
            </IbTypography.Paragraph>
          </div>
        </a>
      ))}
    </div>
  );
};

export default MessageAttachments;
